
export default function ExperienceSection() {
  const experiences = [
    {
      title: "Art Director",
      company: "Blue Prints, Los Angeles, CA",
      period: "April 2012 – Present",
      description: "Helped establish Blue Prints and built its visual and creative direction from the ground up. Lead designer and photographer for branding, marketing campaigns, and digital content.",
      achievements: [
        "Directed a team of creatives in delivering high-quality visual assets for print, digital, and event use",
        "Managed creative production and on-site visual storytelling for live events at Dodger Stadium, collaborating with the Los Angeles Dodgers",
        "Spearheaded the development of branded materials, signage, and promotional content",
        "Oversee project timelines and ensure consistent brand messaging across platforms"
      ]
    },
    {
      title: "Art Director / Co-Founder",
      company: "PRIMs Photo Booth, Los Angeles, CA",
      period: "October 2014 – March 2020",
      description: "Co-founded and launched a full-service photo booth company with unique branding and high-end presentation. Built the graphics department from scratch.",
      achievements: [
        "Trained and supervised staff in California and Arizona",
        "Created custom event-themed graphics for corporate functions, weddings, and private events",
        "Led marketing and visual communications, increasing bookings through brand recognition"
      ]
    },
    {
      title: "Master Photographer",
      company: "Lifetouch, Pasadena, CA",
      period: "February 2006 – August 2013",
      description: "Delivered high-volume portrait photography for schools, senior photos, and studio sessions. Specialized in event photography for proms, dances, and graduations.",
      achievements: [
        "Trained new photographers and maintained photography standards in fast-paced environments",
        "Specialized in event photography for proms, dances, and graduations",
        "Delivered consistent quality in high-volume portrait sessions"
      ]
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 leading-tight">
            Professional 
            <span className="block font-medium">experience</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            A journey through diverse creative environments, each contributing to a comprehensive understanding of design strategy and execution.
          </p>
        </div>
        
        <div className="space-y-12">
          {experiences.map((exp, index) => (
            <div key={index} className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
              <div className="lg:text-right">
                <h3 className="text-xl font-medium text-gray-900 mb-2">{exp.title}</h3>
                <div className="text-gray-600 mb-2">{exp.company}</div>
                <div className="text-sm text-gray-500">{exp.period}</div>
              </div>
              
              <div className="lg:col-span-2">
                <p className="text-gray-600 mb-4 leading-relaxed">{exp.description}</p>
                <div className="space-y-2">
                  {exp.achievements.map((achievement, idx) => (
                    <div key={idx} className="flex items-start space-x-3">
                      <div className="w-1.5 h-1.5 bg-gray-400 rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-gray-600 text-sm">{achievement}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
